export default __webpack_public_path__ + "static/media/water-hand.fc5a318f.svg";